import { Segmented as SegmentedAD } from 'antd';
import type { SegmentedProps } from 'antd/es/segmented';
import cn from 'classnames';
import styles from './segmented.module.css';

export type { SegmentedOptions } from 'antd/es/segmented';

const Segmented = <ValueType,>({ className, size = 'middle', ...rest }: SegmentedProps<ValueType>) => (
  <SegmentedAD
    className={cn({ [styles['ui-segmented--size-middle'] ?? '']: size === 'middle' }, className)}
    size={size}
    {...rest}
  />
);

export default Segmented;
